import * as React from 'react';
export const IcHandOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15 4c-.55 0-1 .45-1 1v.76l1.56-1.56c-.16-.11-.35-.2-.56-.2zm-5 0c0-.55-.45-1-1-1s-1 .45-1 1v7.76l2-2V4zm3-1c0-.55-.45-1-1-1s-1 .45-1 1v5.76l2-2V3zm-6 9.5V7c0-.55-.45-1-1-1s-1 .45-1 1v7.76l2.05-2.05A.465.465 0 017 12.5zm13.71-7.79A.996.996 0 1019.3 3.3L3.29 19.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l1.6-1.6c1.19 1.7 3.09 2.85 5.28 2.89 3.06.06 5.72-1.88 6.6-4.8l1.77-5.91a.998.998 0 00-.53-1.19.992.992 0 00-1.26.34l-1.71 2.56a.25.25 0 01-.46-.14V9.41l4.71-4.71v.01z'
      fill='currentColor'
    />
  </svg>
);
